import {Spin} from 'antd';
import React, {useContext, useEffect} from 'react';
import {match as Match, useRouteMatch} from "react-router-dom";

import {
    createQuery,
    fetchProjects,
    selectCurrent,
    selectProject,
    selectProjects,
    setCurrentQuery,
    setCurrentStudy,
} from './cohortBuilderSlice';
import {useAppDispatch, useAppSelector} from '../../hooks';
import {Routes} from '../../pages/routes';
import SettingsContext from "../../reducers/SettingsContext";
import {DATA_RANGE_IP} from "../../reducers/settings";
import {StudyContent} from "./StudyContent";
import {selectResources} from "../../actions/userSlice";
import {datasets} from "../../components/cohort-queries/ListQueries";

export type ProjectIds = {
  projectId: string,
  studyId?: string
}

export const extractRouteIds = (match: Match<ProjectIds>) => {
  const projectId = parseInt(match.params.projectId)
  const studyId = match.params.studyId === undefined ? NaN : parseInt(match.params.studyId)

  return {
    projectId: isNaN(projectId) ? undefined : projectId,
    studyId: isNaN(studyId) ? undefined : studyId
  }
}

const Study = () => {
  const settings = useContext(SettingsContext)

  const match = useRouteMatch<ProjectIds>(Routes.Project)
  const { projectId, studyId } = extractRouteIds(match)

  const studies = useAppSelector(selectProjects)
  const project = useAppSelector(selectProject(projectId))

  const dispatch = useAppDispatch()
  const current = useAppSelector(selectCurrent)

  const selectedProject = current.study
  const selectedStudy = current.query

  const resources = useAppSelector(selectResources)
  const cbDatasets = datasets(resources)

  useEffect(() => {
    if (studies === undefined) {
      dispatch(fetchProjects())
    }
  }, [dispatch, studies])

  useEffect(() => {
    if (project !== undefined) {
      dispatch(setCurrentStudy(project))

      if (project.queries.length === 0 && cbDatasets.length > 0) {
        dispatch(createQuery({dataset: cbDatasets[0]}))
      }
    }
  }, [project, dispatch]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (studyId !== undefined && studies !== undefined) {
      dispatch(setCurrentQuery(studyId))
    }
  }, [studyId, studies, dispatch])


  if (project === undefined || selectedStudy === undefined || settings[DATA_RANGE_IP] === undefined) {
    return <Spin size="large"/>
  }

  return <div className="study">
        <StudyContent project={selectedProject} study={selectedStudy}/>
  </div >
}

export default Study